import { useQuery } from "@tanstack/react-query";
import { salesAgentService } from "@/services/salesAgentService";
import { walletService } from "@/services/walletService";

/**
 * Dashboard data for the logged-in sales agent.
 */
export function useSalesAgentDashboardData(userId: string | undefined) {
  const {
    data: dashboard,
    isLoading: isLoadingDashboard,
    error: dashboardError,
  } = useQuery({
    queryKey: ["sales-agent-dashboard"],
    queryFn: () => salesAgentService.getMyDashboard(),
    enabled: !!userId,
  });

  const { data: recentTx, isLoading: isLoadingRecent } = useQuery({
    queryKey: ["sales-agent-wallet-transactions", userId, "recent"],
    queryFn: () => walletService.getTransactions(userId!, { limit: 8 }),
    enabled: !!userId,
  });

  const isLoading = isLoadingDashboard || isLoadingRecent;

  return {
    dashboard,
    recentTransactions: recentTx?.items ?? [],
    isLoading,
    error: dashboardError,
  };
}
